<template>
  <div class="app-container pwdBox">
    <el-col id="changePwd" :span="24">
      <el-form
        ref="form"
       
        :model="data"
        status-icon
        :rules="formRules"
        style="margin:10px"
        label-position="left"
        @keyup.enter.native="submit"
      >
        <el-form-item label="原密码" prop="OldPwd">
          <el-input show-password v-model.trim="data.OldPwd" />
        </el-form-item>
        <el-form-item label="新密码" prop="NewPwd">
          <el-input show-password v-model.trim="data.NewPwd" />
        </el-form-item>
        <el-form-item label="确认密码" prop="ConfirmPwd">
          <el-input show-password v-model.trim="data.ConfirmPwd" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submit">保 存</el-button>
        </el-form-item>
      </el-form>
    </el-col>
  </div>
</template>
<script>
import api from "@/api/sy/user";

export default {
  data() {
    let validator = (rule, value, callback) => {
      if (this.data.NewPwd == "" || this.data.ConfirmPwd == "") {
        callback();
      }
      if (this.data.NewPwd != this.data.ConfirmPwd) {
        callback("密码不一致");
      } else {
        callback();
      }
    };
    return {
      data: {
        OldPwd: "",
        NewPwd: "",
        ConfirmPwd: "",
      },
      formRules: {
        OldPwd: [{ required: true, message: "原密码不能为空" }],
        NewPwd: [
          { required: true, message: "新密码不能为空" },
          { validator: this.$commonJs.validateRules.validPwd },
          { validator: validator },
        ],
        ConfirmPwd: [
          { required: true, message: "确认密码不能为空" },
          { validator: validator },
        ],
      },
    };
  },
  methods: {
    submit() {
      let form = this.formValidate();
      form.then((valid) => {
        if (!valid) {
          return;
        }
        // this.$message({
        //   message: "保存成功",
        //   type: "success",
        //   duration: 3000
        // });
        api.changePwd(this.data).then((res) => {
          // console.log(res);
          if (res.Code == 1) {
            this.$message.error(res.Msg);
          } else {
            this.$message({
              message: res.Msg,
              type: "success",
              duration: 3000,
            });
            this.$driver.moveNext();
            this.$alert("修改密码后需要重新登录", "提示", {
              confirmButtonText: "确定",
              showClose: false,
              callback: (action) => {
                this.logout();
              },
            });
          }
        });
      });
    },
    async logout() {
      // await this.$store.dispatch("setChangePwd", false);
      await this.$store.dispatch("logout");
    },
    formValidate() {
      return this.$refs.form
        .validate()
        .then((valid) => {
          return valid;
        })
        .catch(() => {
          this.$notify({
            title: "提示",
            message: "请检查相关字段（红色）填写是否规范",
            type: "warning",
            position: "top-left",
          });
          return false;
        });
    },
  },
};
</script>
<style lang="scss">
.pwdBox {
  @media screen and (min-width: 481px) {
    width: 400px !important;
  }
}
</style>